import React from 'react';
import { ReactComponent as NotFoundImage } from '../../../assets/not-found-image.svg';
import './PageNotFound.css';

const PageNotFound = () => (
  <div className="container">
    <span className="not-found-title">404</span>
    <span className="explanation">We couldn’t find the page you’re looking for</span>
    <span className="explanation">
      Try checking the URL or{' '}
      <button className="go-back-button" onClick={() => window.history.back()}>
        go back
      </button>
    </span>
    <div className="color-rect-div"></div>
    <NotFoundImage className="robo-image" />
  </div>
);

export default PageNotFound;
